__turbopack_context__.v({
  "close": "style-module-scss-module__dencOa__close",
  "close-form": "style-module-scss-module__dencOa__close-form",
  "fadeIn": "style-module-scss-module__dencOa__fadeIn",
  "fadeInMobile": "style-module-scss-module__dencOa__fadeInMobile",
  "fadeOut": "style-module-scss-module__dencOa__fadeOut",
  "fadeOutMobile": "style-module-scss-module__dencOa__fadeOutMobile",
  "form-component": "style-module-scss-module__dencOa__form-component",
  "header": "style-module-scss-module__dencOa__header",
  "hide-button": "style-module-scss-module__dencOa__hide-button",
  "learn-more-button": "style-module-scss-module__dencOa__learn-more-button",
  "learn-more-form": "style-module-scss-module__dencOa__learn-more-form",
  "open-form": "style-module-scss-module__dencOa__open-form",
  "show-button": "style-module-scss-module__dencOa__show-button",
});
